import { state } from '@/store/product/state';
import { actions } from '@/store/product/actions';
import { mutations } from '@/store/product/mutations';
import { getters } from '@/store/product/getters';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export { state, mutations, actions, getters };
